//@flow
const returnEmptyIfUndefinedOrNull = value => {
  if (value === undefined || value === null) {
    return "";
  } else {
    return value;
  }
};

const returnZeroIfUndefinedOrNull = value => {
  if (value === undefined || value === null) {
    return 0;
  } else {
    return value;
  }
};

export const mapMaterialLineItemData = (
  lineItems: {
    Upper: Array<Object>,
    midsole: Array<Object>,
    Packaging: Array<Object>,
    Outsole: Array<Object>,
    Airbag: Array<Object>,
    Missing: Array<Object>
  },
  sortOrder,
  isNby
) => {
  let hideColumn = false;
  if (sortOrder === undefined) {
    hideColumn = true;
  }
  if (isNby) {
    return {
      missing: mapLogicBomMaterialLineItems(lineItems.Missing),
      upper: mapLogicBomMaterialLineItems(
        lineItems.Upper.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      midsole: mapLogicBomMaterialLineItems(
        lineItems.midsole.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      outsole: mapLogicBomMaterialLineItems(
        lineItems.Outsole.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      airbag: mapLogicBomMaterialLineItems(
        lineItems.Airbag.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      packaging: mapLogicBomMaterialLineItems(
        lineItems.Packaging.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      )
    };
  } else {
    return {
      missing: mapMaterialLineItems(lineItems.Missing),
      upper: mapMaterialLineItems(
        lineItems.Upper.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      midsole: mapMaterialLineItems(
        lineItems.midsole.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      outsole: mapMaterialLineItems(
        lineItems.Outsole.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      airbag: mapMaterialLineItems(
        lineItems.Airbag.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      ),
      packaging: mapMaterialLineItems(
        lineItems.Packaging.sort((a, b) => Number(a[sortOrder]) - Number(b[sortOrder])),
        hideColumn
      )
    };
  }
};

export const mapLaborLineItemData = (lineItems: {
  "Upper Preparation": Array<Object>,
  "Upper Construction": Array<Object>,
  "Upper Embellishment": Array<Object>,
  "Bottom Making": Array<Object>,
  "Bottom Embellishment": Array<Object>,
  Stockfitting: Array<Object>,
  Assembly: Array<Object>,
  Missing: Array<Object>
}) => {
  return {
    missing: mapLaborLineItems(lineItems["Missing"]),
    "Upper Preparation": mapLaborLineItems(lineItems["Upper Preparation"]),
    "Upper Construction": mapLaborLineItems(lineItems["Upper Construction"]),
    "Upper Embellishment": mapLaborLineItems(lineItems["Upper Embellishment"]),
    "Bottom Making": mapLaborLineItems(lineItems["Bottom Making"]),
    "Bottom Embellishment": mapLaborLineItems(lineItems["Bottom Embellishment"]),
    Stockfitting: mapLaborLineItems(lineItems["Stockfitting"]),
    Assembly: mapLaborLineItems(lineItems["Assembly"])
  };
};

const mapMaterialLineItems = (section: Array<Object>, noSort: boolean) => {
  if (!section || section.length === 0) return [];
  if (noSort) {
    return section.map(materialLineItems => {
      return {
        "PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartName),
        "PATTERN PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePatternPartName),
        "MTL TYPE": returnEmptyIfUndefinedOrNull(materialLineItems.flexTypeIdPath),
        "PCX MTL NUMBER": returnEmptyIfUndefinedOrNull(materialLineItems.pcxMaterialNumber),
        "MTL NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikeMaterialName),
        "SUPPLIED MATERIAL NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeSupplierMaterialCode
        ),
        "PDM MATERIAL BY SUPPLIER NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems["nikeLegacySupplierMaterial "]
        ),
        "SUPPLIER LOCATION": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLocationName),
        COLOR: returnEmptyIfUndefinedOrNull(materialLineItems.name),
        "PROFIT EXCLUDED": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetMaterialProfitExclusionIndicator
        ),
        "PART YIELD": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartYield),
        "ACTUAL MTL DIM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyActualDimension),
        "PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetIsoMeasurementCode),
        "UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetUnitPrice),
        CURR: returnEmptyIfUndefinedOrNull(materialLineItems.costsheetMtlCurrencyCode),
        "MTL PRICE EFFECTIVE DATE": returnEmptyIfUndefinedOrNull(
          materialLineItems.materialPriceEffectiveDate
        ),
        "FCTY PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyISOMeasurementCode),
        "FCTY CURR": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCurrencyCode),
        "FCTY UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFactoryUnitPrice),
        "UNIT PRICE UPCHG": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpcharge
        ),
        "UPCHG DESC": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpchargeDescription
        ),
        "TOTAL UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetTotalUnitPrice),
        "FCTY IN-HOUSE": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyFactoryInhouseindicator
        ),
        "FRT TRM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFreightTermIdentifier),
        "COUNTRY OF ORIGIN": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCountryofOrigin),
        "LND %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLandedCostPercent),
        "TTL LND UNIT COST": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetTotalLandedUnitCost
        ),
        "CONS CONV RATE (g/cm2)": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeConsumptionConversionRate
        ),
        "USAGE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeISOMeasurementCode),
        "NET USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyNetUsage),
        "NET LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedNetCost),
        "WASTE USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyWasteUsage),
        "WASTE LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedWasteCost),
        "GROSS USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetGrossUsage),
        "GROSS LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedGrossCost),
        "EFF %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeUsageEfficiency),
        "DEFECT %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLineItemDefectPercent),
        "DEFECT LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedDefectCost),
        "US LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedCostUSD),
        COMMENTS: returnEmptyIfUndefinedOrNull(materialLineItems.nikeBomlinkComments)
      };
    });
  } else if (!noSort) {
    return section.map(materialLineItems => {
      return {
        sortingNumberInt: returnEmptyIfUndefinedOrNull(materialLineItems.sortingNumberInt),
        pccSortOrder: returnEmptyIfUndefinedOrNull(materialLineItems.pccSortOrder),
        "PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartName),
        "PATTERN PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePatternPartName),
        "MTL TYPE": returnEmptyIfUndefinedOrNull(materialLineItems.flexTypeIdPath),
        "PCX MTL NUMBER": returnEmptyIfUndefinedOrNull(materialLineItems.pcxMaterialNumber),
        "MTL NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikeMaterialName),
        "SUPPLIED MATERIAL NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeSupplierMaterialCode
        ),
        "PDM MATERIAL BY SUPPLIER NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems["nikeLegacySupplierMaterial "]
        ),
        "SUPPLIER LOCATION": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLocationName),
        COLOR: returnEmptyIfUndefinedOrNull(materialLineItems.name),
        "PROFIT EXCLUDED": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetMaterialProfitExclusionIndicator
        ),
        "PART YIELD": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartYield),
        "ACTUAL MTL DIM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyActualDimension),
        "PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetIsoMeasurementCode),
        "UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetUnitPrice),
        CURR: returnEmptyIfUndefinedOrNull(materialLineItems.costsheetMtlCurrencyCode),
        "MTL PRICE EFFECTIVE DATE": returnEmptyIfUndefinedOrNull(
          materialLineItems.materialPriceEffectiveDate
        ),
        "FCTY PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyISOMeasurementCode),
        "FCTY CURR": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCurrencyCode),
        "FCTY UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFactoryUnitPrice),
        "UNIT PRICE UPCHG": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpcharge
        ),
        "UPCHG DESC": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpchargeDescription
        ),
        "TOTAL UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetTotalUnitPrice),
        "FCTY IN-HOUSE": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyFactoryInhouseindicator
        ),
        "FRT TRM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFreightTermIdentifier),
        "COUNTRY OF ORIGIN": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCountryofOrigin),
        "LND %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLandedCostPercent),
        "TTL LND UNIT COST": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetTotalLandedUnitCost
        ),
        "CONS CONV RATE (g/cm2)": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeConsumptionConversionRate
        ),
        "USAGE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeISOMeasurementCode),
        "NET USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyNetUsage),
        "NET LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedNetCost),
        "WASTE USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyWasteUsage),
        "WASTE LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedWasteCost),
        "GROSS USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetGrossUsage),
        "GROSS LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedGrossCost),
        "EFF %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeUsageEfficiency),
        "DEFECT %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLineItemDefectPercent),
        "DEFECT LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedDefectCost),
        "US LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedCostUSD),
        COMMENTS: returnEmptyIfUndefinedOrNull(materialLineItems.nikeBomlinkComments)
      };
    });
  }
};

const mapLogicBomMaterialLineItems = (section: Array<Object>, noSort: boolean) => {
  if (!section || section.length === 0) return [];
  if (noSort) {
    return section.map(materialLineItems => {
      return {
        "LOGIC GROUP": returnEmptyIfUndefinedOrNull(materialLineItems.logicGroup),
        "PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartName),
        "PATTERN PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePatternPartName),
        "MTL TYPE": returnEmptyIfUndefinedOrNull(materialLineItems.flexTypeIdPath),
        "PCX MTL NUMBER": returnEmptyIfUndefinedOrNull(materialLineItems.pcxMaterialNumber),
        "MTL NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikeMaterialName),
        "SUPPLIED MATERIAL NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeSupplierMaterialCode
        ),
        "PDM MATERIAL BY SUPPLIER NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems["nikeLegacySupplierMaterial "]
        ),
        "SUPPLIER LOCATION": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLocationName),
        COLOR: returnEmptyIfUndefinedOrNull(materialLineItems.name),
        "PROFIT EXCLUDED": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetMaterialProfitExclusionIndicator
        ),
        "PART YIELD": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartYield),
        "ACTUAL MTL DIM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyActualDimension),
        "PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetIsoMeasurementCode),
        "UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetUnitPrice),
        CURR: returnEmptyIfUndefinedOrNull(materialLineItems.costsheetMtlCurrencyCode),
        "MTL PRICE EFFECTIVE DATE": returnEmptyIfUndefinedOrNull(
          materialLineItems.materialPriceEffectiveDate
        ),
        "FCTY PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyISOMeasurementCode),
        "FCTY CURR": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCurrencyCode),
        "FCTY UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFactoryUnitPrice),
        "UNIT PRICE UPCHG": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpcharge
        ),
        "UPCHG DESC": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpchargeDescription
        ),
        "TOTAL UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetTotalUnitPrice),
        "FCTY IN-HOUSE": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyFactoryInhouseindicator
        ),
        "FRT TRM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFreightTermIdentifier),
        "COUNTRY OF ORIGIN": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCountryofOrigin),
        "LND %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLandedCostPercent),
        "TTL LND UNIT COST": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetTotalLandedUnitCost
        ),
        "CONS CONV RATE (g/cm2)": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeConsumptionConversionRate
        ),
        "USAGE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeISOMeasurementCode),
        "NET USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyNetUsage),
        "NET LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedNetCost),
        "WASTE USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyWasteUsage),
        "WASTE LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedWasteCost),
        "GROSS USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetGrossUsage),
        "GROSS LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedGrossCost),
        "EFF %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeUsageEfficiency),
        "DEFECT %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLineItemDefectPercent),
        "DEFECT LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedDefectCost),
        "US LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedCostUSD),
        "MTL FCST %": returnEmptyIfUndefinedOrNull(
          materialLineItems.materialForecastPercent
        ),
        COMMENTS: returnEmptyIfUndefinedOrNull(materialLineItems.nikeBomlinkComments)
      };
    });
  } else if (!noSort) {
    return section.map(materialLineItems => {
      return {
        sortingNumberInt: returnEmptyIfUndefinedOrNull(materialLineItems.sortingNumberInt),
        pccSortOrder: returnEmptyIfUndefinedOrNull(materialLineItems.pccSortOrder),
        "LOGIC GROUP": returnEmptyIfUndefinedOrNull(materialLineItems.logicGroup),
        "PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartName),
        "PATTERN PART NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikePatternPartName),
        "MTL TYPE": returnEmptyIfUndefinedOrNull(materialLineItems.flexTypeIdPath),
        "PCX MTL NUMBER": returnEmptyIfUndefinedOrNull(materialLineItems.pcxMaterialNumber),
        "MTL NAME": returnEmptyIfUndefinedOrNull(materialLineItems.nikeMaterialName),
        "SUPPLIED MATERIAL NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeSupplierMaterialCode
        ),
        "PDM MATERIAL BY SUPPLIER NUMBER": returnEmptyIfUndefinedOrNull(
          materialLineItems["nikeLegacySupplierMaterial "]
        ),
        "SUPPLIER LOCATION": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLocationName),
        COLOR: returnEmptyIfUndefinedOrNull(materialLineItems.name),
        "PROFIT EXCLUDED": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetMaterialProfitExclusionIndicator
        ),
        "PART YIELD": returnEmptyIfUndefinedOrNull(materialLineItems.nikePartYield),
        "ACTUAL MTL DIM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyActualDimension),
        "PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetIsoMeasurementCode),
        "UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetUnitPrice),
        CURR: returnEmptyIfUndefinedOrNull(materialLineItems.costsheetMtlCurrencyCode),
        "MTL PRICE EFFECTIVE DATE": returnEmptyIfUndefinedOrNull(
          materialLineItems.materialPriceEffectiveDate
        ),
        "FCTY PRICE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyISOMeasurementCode),
        "FCTY CURR": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCurrencyCode),
        "FCTY UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFactoryUnitPrice),
        "UNIT PRICE UPCHG": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpcharge
        ),
        "UPCHG DESC": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyUnitPriceUpchargeDescription
        ),
        "TOTAL UNIT PRICE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetTotalUnitPrice),
        "FCTY IN-HOUSE": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeFtyFactoryInhouseindicator
        ),
        "FRT TRM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyFreightTermIdentifier),
        "COUNTRY OF ORIGIN": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyCountryofOrigin),
        "LND %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLandedCostPercent),
        "TTL LND UNIT COST": returnEmptyIfUndefinedOrNull(
          materialLineItems.costsheetTotalLandedUnitCost
        ),
        "CONS CONV RATE (g/cm2)": returnEmptyIfUndefinedOrNull(
          materialLineItems.nikeConsumptionConversionRate
        ),
        "USAGE UOM": returnEmptyIfUndefinedOrNull(materialLineItems.nikeISOMeasurementCode),
        "NET USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyNetUsage),
        "NET LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedNetCost),
        "WASTE USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyWasteUsage),
        "WASTE LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedWasteCost),
        "GROSS USAGE": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetGrossUsage),
        "GROSS LND $": returnEmptyIfUndefinedOrNull(materialLineItems.nikeLandedGrossCost),
        "EFF %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeUsageEfficiency),
        "DEFECT %": returnEmptyIfUndefinedOrNull(materialLineItems.nikeFtyLineItemDefectPercent),
        "DEFECT LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedDefectCost),
        "US LND $": returnEmptyIfUndefinedOrNull(materialLineItems.costsheetLandedCostUSD),
        "MTL FCST %": returnEmptyIfUndefinedOrNull(
          materialLineItems.materialForecastPercent
        ),
        COMMENTS: returnEmptyIfUndefinedOrNull(materialLineItems.nikeBomlinkComments)
      };
    });
  }
};

const mapLaborLineItems = section => {
  if (!section || section.length === 0) return [];
  return section.map(LaborLineItems => {
    return {
      "PART NAME": returnEmptyIfUndefinedOrNull(LaborLineItems.nikePartName),
	  "SEQUENCE": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetBolSequenceOrderIdentifier),
	  "DESCRIPTION": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetBolLineItemDescription),
      "MANUFACTURING PROCESS": returnEmptyIfUndefinedOrNull(LaborLineItems.manufacturingProcess),
      "LABOR PROCESS NAME": returnEmptyIfUndefinedOrNull(LaborLineItems.nikeLaborProcessName),
      "LABOR PROCESS ID": returnEmptyIfUndefinedOrNull(LaborLineItems.nikeLaborProcessID),
      "LABOR PROCESS STATUS": returnEmptyIfUndefinedOrNull(LaborLineItems.nikeStatus),
      "FCTY IN-HOUSE": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetInhouseIndicator),
      "IS CUSTOM": returnEmptyIfUndefinedOrNull(LaborLineItems.nikeIsCustom),
      "IS PLACEHOLDER": returnEmptyIfUndefinedOrNull(LaborLineItems.nikePlaceholder),
      COUNT: returnEmptyIfUndefinedOrNull(LaborLineItems.quantity),
      "LENGTH (cm)": returnZeroIfUndefinedOrNull(LaborLineItems.nikeLength),
      "CABLE COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikeCableCount),
      "CLIP COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikeClipCount),
      "PIN COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikePinCount),
      "PRESS COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikePressCount),
      "RUBBER PREFORM COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikeRubberComponentCount),
      "SHOE COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikeShoeCount),
      "SLIT COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikeSlitCount),
      "TRIM COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikeTrimCount),
      "PATCH COUNT": returnZeroIfUndefinedOrNull(LaborLineItems.nikePatchCount),
      "STANDARD MINUTES": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetStandardMinutesValue),
      "OBSERVED MINUTES": returnEmptyIfUndefinedOrNull(LaborLineItems.billoflaborObservedMinutes),
      "TOTAL STANDARD MINUTES": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetTotalStandardMinutes),
      "TOTAL OBSERVED MINUTES": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetTotalObservedMinutes),
      "LABOR MINUTES": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetTotalLaborMinutes),
      "OUTSOURCED LABOR COST": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetOutsourcedLaborCost),
      "OUTSOURCED LABOR COST CURRENCY": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetOutsourcedLaborCostCurrency),
      "LABOR COST": returnEmptyIfUndefinedOrNull(LaborLineItems.costsheetLaborCostUsd),
      COMMENTS: returnEmptyIfUndefinedOrNull(LaborLineItems.nikeBomlinkComments)
    };
  });
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/cbdLineItemMapping.js